import React from 'react';
import './PassengerEnglishName.css';

function PassengerEnglishName({ lastName, firstName, fallbackName }) {
  const surname = String(lastName ?? '').trim();
  const givenName = String(firstName ?? '').trim();

  // Older display data may contain only a combined name; do not guess its parts.
  if (!surname && !givenName && fallbackName) {
    return <span>{fallbackName}</span>;
  }

  return (
    <span className='passenger-english-name'>
      <span className='passenger-english-name-field'>
        <span className='passenger-english-name-label'>영문 성 (Last Name)</span>
        <span className='passenger-english-name-value'>{surname || '-'}</span>
      </span>
      <span className='passenger-english-name-field'>
        <span className='passenger-english-name-label'>영문 이름 (First Name)</span>
        <span className='passenger-english-name-value'>{givenName || '-'}</span>
      </span>
    </span>
  );
}

export default PassengerEnglishName;
